// src/frontend/js/modern/entry-free.js
import { createModernSystem } from './system.js';
import wishlistModule from './modules/wishlist/index.js';

const modernSystem = createModernSystem([wishlistModule]);

document.addEventListener('DOMContentLoaded', () => {
	modernSystem.init({ premium: false });
});

export default modernSystem;
